module.exports = __webpack_public_path__ + "img/image-hero-right.95d59a0c.png";